import { forkJoin, Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  ENVIRONMENT,
  EnvironmentModel,
} from '@lyceo/lyceo-pupil-app/shared/util-environment';

import { Injectable, inject } from '@angular/core';
import { ParagraphDto } from './+state/paragraph/paragraph.model';
@Injectable({
  providedIn: 'root',
})
export class ParagraphService {
  private readonly environment: EnvironmentModel =
    inject<EnvironmentModel>(ENVIRONMENT);
  private readonly http: HttpClient = inject(HttpClient);

  public getParagraph(id: string): Observable<ParagraphDto> {
    const url: string = `${this.environment.biebApiUrl}/api/v3/paragraphs/${id}`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.get<ParagraphDto>(url, {
      headers: headersToSend,
    });
  }

  public getParagraphByIds(ids: string[]): Observable<ParagraphDto[]> {
    if (!ids.length) {
      return of([]);
    }
    return forkJoin(ids.map((id) => this.getParagraph(id)));
  }
}
